import PlusOutlined from '@ant-design/icons/lib/icons/PlusOutlined';
import { Button, Table, Tooltip } from 'antd';
import { ColumnsType, TablePaginationConfig } from 'antd/lib/table';
import { FilterValue, SorterResult } from 'antd/lib/table/interface';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { Link } from 'react-router-dom';
import organizationApi from '../../../apis/OrganizationApi';
import LayoutComponent from '../../../components/LayoutComponent/LayoutComponent';
import CustomContext from '../../../context/CustomContext';
import { Page } from '../../../model/Elements';
import { Organization } from '../../../model/Entities';
import notificationService from '../../../services/NotificationService';
import tableService from '../../../services/TableService';
import styles from './OrganizationsPage.module.scss';

class OrganizationsPage extends Component<Props, State> {
    static contextType = CustomContext;
    context!: React.ContextType<typeof CustomContext>;

    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.init();
    }

    /** METHODS **/

    init = async () => {
        try {
            this.setState({ loading: true });
            const organizationsPage = await organizationApi.list(tableService.pageSize, 1);
            this.setState({ organizationsPage });
        } catch (error) {
        } finally {
            this.setState({ loading: false });
        }
    };

    list = async (
        pagination: TablePaginationConfig,
        filters: Record<string, FilterValue | null>,
        sorter: SorterResult<Organization> | SorterResult<Organization>[],
    ) => {
        try {
            this.setState({ loading: true });
            const page = pagination.current!;
            const pageSize = pagination.pageSize!;
            let sortField, sortOrder;
            if (Array.isArray(sorter)) {
            } else {
                sortField = sorter.field as string;
                sortOrder = sorter.order as string;
            }
            const organizationsPage = await organizationApi.list(pageSize, page, sortField, sortOrder);
            this.setState({ organizationsPage });
        } catch (error) {
            notificationService.displayError(error, this.props.intl);
        } finally {
            this.setState({ loading: false });
        }
    };

    /*** COMPONENTS ***/

    renderContent = (): React.ReactElement | undefined => {
        return (
            <>
                {this.renderToolbar()}
                <div className={styles.table}>{this.renderTable()}</div>
            </>
        );
    };

    renderToolbar = (): React.ReactElement | undefined => {
        return (
            <div className={styles.toolbar}>
                <h1>
                    <FormattedMessage id="organizations.title" />
                </h1>
                <Link to="/admin/organizations/new">
                    <Tooltip title={<FormattedMessage id="organizations.tooltip" />}>
                        <Button type="primary" size="large" className={styles.add} icon={<PlusOutlined />}>
                            <FormattedMessage id="organizations.add" />
                        </Button>
                    </Tooltip>
                </Link>
            </div>
        );
    };

    renderTable = (): React.ReactElement | undefined => {
        const { organizationsPage, loading } = this.state;
        const items = organizationsPage ? organizationsPage.items : [];
        const columns: ColumnsType<Organization> = [
            {
                title: <FormattedMessage id="organizations.name" />,
                dataIndex: 'name',
                key: 'name',
                sorter: true,
                defaultSortOrder: 'ascend',
                render: (value: string, organization: Organization) => (
                    <Link to={`/admin/organizations/${organization.id}`}>{value}</Link>
                ),
            },
            {
                title: <FormattedMessage id="organizations.address" />,
                dataIndex: 'address',
                key: 'address',
                render: (value: string, organization: Organization) => (
                    <Link to={`/admin/organizations/${organization.id}`}>{value}</Link>
                ),
            },
            {
                title: <FormattedMessage id="organizations.city" />,
                dataIndex: 'city',
                key: 'city',
                render: (value: string, organization: Organization) => (
                    <Link to={`/admin/organizations/${organization.id}`}>{value}</Link>
                ),
            },
            {
                title: <FormattedMessage id="organizations.state" />,
                dataIndex: 'state',
                key: 'state',
                render: (value: string, organization: Organization) => (
                    <Link to={`/admin/organizations/${organization.id}`}>{value}</Link>
                ),
            },
        ];

        return (
            <Table
                dataSource={items}
                columns={columns}
                pagination={tableService.createPagination(organizationsPage)}
                rowKey="id"
                onChange={this.list}
                sortDirections={['ascend', 'descend']}
                showSorterTooltip={false}
                loading={loading}
            />
        );
    };

    render() {
        return <LayoutComponent page="admin-organizations" content={this.renderContent} />;
    }
}
export default injectIntl(OrganizationsPage);

interface Props extends WrappedComponentProps {}

interface State {
    organizationsPage?: Page<Organization>;
    loading?: boolean;
}
